<app-autocomplete-select
    [currentValue]="accountIdValue$ | async"
    [options]="accounts$ | async"
    [loading]="accountsLoading$ | async"
    [noResoultsLabel]="'ci.common.noResults' | translate"
    [placeholder]="'ci.common.selectAccount' | translate"
    (valueChange)="onValueChange($event)"
></app-autocomplete-select>